package com.example.histoire.web

import kotlinx.browser.localStorage

private const val KEY = "histoire_du_soir_app_background_v1"

fun loadAppBackgroundDataUrl(): String? {
    val raw = localStorage.getItem(KEY)?.trim().orEmpty()
    if (raw.isBlank()) return null
    if (!raw.startsWith("data:image/")) return null
    return raw
}

fun saveAppBackgroundDataUrl(dataUrl: String?) {
    if (dataUrl.isNullOrBlank()) {
        localStorage.removeItem(KEY)
        return
    }
    if (!dataUrl.startsWith("data:image/")) return
    localStorage.setItem(KEY, dataUrl)
}
